import get from 'lodash/get';
import { premiumSubscriptionStatus } from '../utils/subscription/subscriptionStatus';
import isSubscribedThroughWeb from '../utils/subscription/subscribedThroughWeb';

const NAMESPACE = 'me';

export const selectUserDetails = (state) => get(state, [NAMESPACE, 'details']);

export const selectSubscriptionStatus = (state) =>
  get(state, [NAMESPACE, 'details', 'subscriptionStatus']);

export const selectSubscriptionProviderName = (state) =>
  get(state, [NAMESPACE, 'details', 'subscriptionProviderName']);

export const selectIsUserSubscribed = (state) =>
  selectSubscriptionStatus(state) === premiumSubscriptionStatus.active;

export const selectIsExpiredWebSubscriber = (state) => {
  const status = selectSubscriptionStatus(state);
  const provider = selectSubscriptionProviderName(state);

  const hasExpiredStatus = status === premiumSubscriptionStatus.expired;
  // has expired web subscription status

  // the user data does not contain if the user is Active but has cancelled their subscription
  // we check this when they try to subscribe or go to their account subscription tab... they will
  // get redirected accordingly at that point
  return hasExpiredStatus && isSubscribedThroughWeb(provider);
};
